
<form [formGroup]="precoUnitarioForm">
  <div class="card" *ngIf="precoUnitarioForm">
    <div class="card-header">
      <h3>{{precoUnitarioForm.controls['descricaoCombustivel'].value}}</h3>
    </div>
  
    <div class="card-body">
          <div class="row justify-content-center">
            <div class="col-3 centralizado">
              <h3 class="text-left comb-titulo">{{precoUnitarioForm.controls['tituloBomba'].value}}</h3>
              <p class="text-left comb-descricao">{{precoUnitarioForm.controls['descricaoBomba'].value}}</p>
            </div>
            <div class="col-2 centralizado">
              <svg mat-raised-button
                   matTooltip="Alteração: {{  precoUnitarioForm.controls['dataInicio'].value  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                  Situação: {{ precoUnitarioForm.controls['dscStatusAcordo'].value  || 'Sem Info' + '\n' }}
                                                  Desde: {{ precoUnitarioForm.controls['datCadastro'].value  | date: 'dd/MM/yyy' || 'Sem Info' }}"
                   aria-label="Button that displays a tooltip when focused or hovered over"
                   matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                   data-container="body" data-toggle="popover" data-trigger="hover"
                   xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                   class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                <path
                  d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
              </svg>
            </div>
            <div class="col-4 centralizado">
  
              <div class="input-group mb-3">
                <span class="input-group-text">R$</span>
                <input class="form-control form-control-lg" 
                type="number"
                min="0" 
                step="0.01"
                formControlName="precoBomba"
                  >
              </div>
            </div>
          </div>
    </div>
    <app-footer (salvarModificacoes)="salvarModificacoesCombustivel($event)"></app-footer>
  </div>
</form>




